module.exports = fox._r("fonts/robotocondensed-regular-webfont.eot", __webpack_public_path__ + "_/_/_/root/fonts/3KD6F5O.eot");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/fonts/robotocondensed-regular-webfont.eot
// module id = 44
// module chunks = 4